import { IsBoolean, IsOptional } from 'class-validator';

export class NotificationTypeDto {
  @IsOptional()
  @IsBoolean()
  push?: boolean;

  @IsOptional()
  @IsBoolean()
  email?: boolean;
}
